// extracted by mini-css-extract-plugin
module.exports = {"expiredToken":"styles_expiredToken__8lmD2","expiredToken__logo":"styles_expiredToken__logo__zyqEj","expiredToken__container":"styles_expiredToken__container__39jN_"};